import VoidItemDetailQueries from './VoidItemDetailQueries.js'

const mvCartLineProperties = {
  mvCartLineProperties: {
    ...VoidItemDetailQueries,
  }
}

export default mvCartLineProperties